import {
  getData,
  postData,
  convertPageModel,
  getFileData
} from './api-base.service'

export const getAccountList = (model) => {
  let data = convertPageModel(model);
  var result = postData('/Finance/GetAccountList', data, true, true);
  return result;
}

export const getAccountListSummary = (model) => {
  let data = convertPageModel(model);
  var result = postData('/Finance/GetAccountListSummary', data, true, true);
  return result;
}

export const getFormulaList = (model) => {
  let data = convertPageModel(model);
  var result = postData('/Finance/GetFormulaList', data);
  return result;
}

export const getFormulaListByType = (formulaType, accountType, accountId) => {
  let data = {
    formulaType: formulaType,
    accountType: accountType,
    accountId: accountId
  };
  var result = getData('/Finance/GetFormulaListByType', data);
  return result;
}

export const saveFormula = (id, accountType, labelName, universityGroups, code, variableName, mapVariableName,
  value, formulaType, isBonusPoint, isBonusPointDeduction, bonusPointDeduction, isEnable, termIds, isRelatedInTerm) => {

  let data = getFormulaModel(id, accountType, labelName, universityGroups, code, variableName, mapVariableName,
    value, formulaType, isBonusPoint, isBonusPointDeduction, bonusPointDeduction, isEnable, termIds, isRelatedInTerm);
  var result = postData('/Finance/SaveFormula', data);
  return result;
}

export const testFormula = (id, accountType, labelName, universityGroups, code, variableName, mapVariableName,
  value, formulaType, isBonusPoint, isBonusPointDeduction, bonusPointDeduction, isEnable, termIds, isRelatedInTerm) => {
    
  let data = getFormulaModel(id, accountType, labelName, universityGroups, code, variableName, mapVariableName,
    value, formulaType, isBonusPoint, isBonusPointDeduction, bonusPointDeduction, isEnable, termIds, isRelatedInTerm);
  var result = postData('/Finance/TestFormula', data);
  return result;
}

let getFormulaModel = function(id, accountType, labelName, universityGroups, code, variableName, mapVariableName,
  value, formulaType, isBonusPoint, isBonusPointDeduction, bonusPointDeduction, isEnable, termIds, isRelatedInTerm){
  if (typeof id == "undefined") {
    id = 0;
  }
  let data = {
    Id: id,
    FormulaType: formulaType,
    AccountType: accountType,
    LabelName: labelName,
    UniversityGroups: universityGroups,
    Code: code,
    VariableName: variableName,
    MapVariableName: mapVariableName,
    Value: value,
    IsBonusPoint: isBonusPoint,
    IsBonusPointDeduction: isBonusPointDeduction,
    BonusPointDeduction: bonusPointDeduction,
    Enable: isEnable,
    TermIds: termIds,
    IsRelatedInTerm: isRelatedInTerm
  };
  return data;
}

export const deleteFormula = (id) => {
  let data = {
    id: id
  };
  var result = getData('/Finance/DeleteFormula', data);
  return result;
}

export const changeFormulaEnable = (id) => {
  let data = {
    id: id
  };
  var result = getData('/Finance/ChangeFormulaEnable', data);
  return result;
}

export const getFormulaTypeList = () => {
  var result = getData('/Finance/GetFormulaTypeList');
  return result;
}

export const checkPayment = (paymentCheckList,accountCheckList) => {
  let data = {PaymentCheckList:paymentCheckList,AccountCheckList:accountCheckList};
  var result = postData('/Finance/CheckPayment', data);
  return result;
}

export const createAccountModel = (defaultType = 0) => {
  return {
    Id: 0,
    StudentId: 0,
    AccountType: defaultType,
    IsAmountChange: false,
    Index: 0,
    StudentPhone: null,
    Amount: 0,
    Debt: 0,
    Comment: null,
    WorkflowId: 0,
    AccountPayments: []
  };
}

export const createAccountPaymentModel = (defaultType = 1) => {
  return {
    Id: 0,
    AccountId: 0,
    UserId: 0,
    PaymentTypeId: defaultType,
    ServiceCharge: 0,
    Amount: 0,
    Comment: null,
    Enable: true
  };
}

export const getAccount = (accountId = null) => {
  let data = {
    accountId: accountId
  };
  let fetchResult = getData('/Finance/GetAccount', data);

  return fetchResult;
}

export const saveAccount = (model) => {
  let data = model;
  let fetchResult = postData('/Finance/SaveAccount', data);

  return fetchResult;
}

export const removeAccountPayment = (id, workMode=null) => {
  let data = {
    id: id
  };
  
  if(!!workMode && workMode == 'ContinuePayment'){
    return getData('/Finance/RemoveContinueAccountPayment', data);
  }
  else{
    let fetchResult = getData('/Finance/RemoveAccountPayment', data);
    return fetchResult;
  }
}

export const getPaymentTypes = (includeCreditCard, isEnableOnly) => {

  if (typeof includeCreditCard == "undefined"){
    includeCreditCard = false;
  }
  if (typeof isEnableOnly == "undefined"){
    isEnableOnly = true;
  }
  let data = {includeCreditCard: includeCreditCard, isEnableOnly: isEnableOnly};
  let result = getData('/Finance/GetPaymentTypes', data);
  return result;
}

export const getPaymentDetails = (model) => {
  let data = convertPageModel(model);
  let result = postData('/Finance/GetPaymentDetails', data);
  return result;
}

export const getSalesQueryList = (model) => {
  let data = convertPageModel(model);
  let result = postData('/Finance/SalesQuery', data);
  return result;
}

export const getSalesQuerySummary = (model) => {
  let data = convertPageModel(model);
  let result = postData('/Finance/SalesQuerySummary', data);
  return result;
}

export const exportSaleQueryCourses = (model) => {
  let data = convertPageModel(model);
  let result = getFileData('/Finance/ExportSaleQueryCourses', data, false);
  return result;
}

export const exportSaleQueryCourseAveragePrice = (model) => {
  let data = convertPageModel(model);
  let result = getFileData('/Finance/ExportSaleQueryCourseAveragePrice', data, false);
  return result;
}

export const saveCourseChange = (model) => { 
  let result = postData("/Finance/SaveCourseChange", model);
  return result;
}

export const saveWeChatTypeChange = (wfId, weChatType) => {
  let data = { WFId: wfId, WeChatType: weChatType };
  let result = postData("/Finance/SaveWeChatTypeChange", data);
  return result;
}
export const saveAccountEnableChange = (acId, enable) => {
  let data = { ACId: acId, Enable: enable };
  let result = postData("/Finance/SaveAccountEnableChange", data);
  return result;
}

export const saveContractChange = (wfId, contractId) => {
  let data = { WFId: wfId, ContractId: contractId };
  let result = postData("/Finance/SaveContractChange", data);
  return result;
}

export const saveCommentsChange = (wfId, comments)=>{
  let data = { WFId: wfId, Comments: comments };
  let result = postData("/Finance/SaveCommentsChange", data);
  return result;
}

export const getRefundDetail = (workflowCourseId, workflowId, refundHistoryId, isAllRefundToDebt=false)=>{
  let data = {
    WorkflowCourseId: workflowCourseId,
    WorkflowId:workflowId,
    refundHistoryId:refundHistoryId,
    isAllRefundToDebt:isAllRefundToDebt
  };
  let result = getData('/Finance/GetRefundDetailViewModel', data);
  return result;
}

export const getOtherCollectFeeRefundDetail = (workflowId)=>{
  let data = {
    WorkflowId: workflowId
  };
  let result = getData('/Finance/GetOtherCollectFeeRefundDetailViewModel', data);
  return result;
}

export const saveRefund = (model)=>{ 
  let result = postData("/Finance/SaveRefund", model);
  return result;
}

export const saveOtherCollectFeeRefund = (model)=>{ 
  let result = postData("/Finance/SaveOtherCollectFeeRefund", model);
  return result;
} 

export const getChangeCourseModel = (workflowCourseId, termId, studentId)=>{
  let data = {
    workflowCourseId: workflowCourseId,
    termId:termId,
    studentId:studentId
  };
  let result = getData('/Finance/GetChangeCourseViewModel', data);
  return result;
}

export const calculateChangeCourseEnrollmentFee = (model)=>{
  let result = postData("/Finance/CalculateChangeCourseEnrollmentFee",model);
  return result;
}

//保存使用积分、余额、占位、现金减
export const saveContinuePayment = (model) => {
  let data = model;
  let fetchResult = postData('/Finance/SaveContinuePayment', data); 
  return fetchResult;
}

export const saveContinueAccountPayment = (model) => {
  let data = model;
  let fetchResult = postData('/Finance/SaveContinueAccountPayment', data); 
  return fetchResult;
} 

export const getPerformanceEvaluationResult = (data) => {
  let result = postData('/Finance/GetEmployeePerformance', data);
  return result;
}

export const resetAccountHighlight = (accountId) => {
  let result = getData('/Finance/ResetAccountHighlight', {accountId: accountId});
  return result;
}

export const createCreditCardPayment = (data) => {
  let result = postData('/Finance/CreateCreditCardPayment', data);
  return result;
}

export const savePaymentComment = (accountPaymentId, comment) => {
  let data = {
    AccountPaymentId: accountPaymentId,
    Comment: comment
  };
  return postData('/Finance/SavePaymentComment', data);
}

export const saveAccountComment = (accountId, comment) => {
  let data = {
    AccountId: accountId,
    Comment: comment
  };
  return postData('/Finance/SaveAccountComment', data);
}

export const getVipUnconsumedTotalAmount = (universityId) => {
  if (typeof universityId == "undefined"){
    universityId = 0;
  }else if (universityId == ''){
    universityId = 0;
  }
  let data = {
    universityId: universityId
  };
  var result = getData('/Finance/GetVipUnconsumedTotalAmount', data);
  return result;
}


// WEBPACK FOOTER //
// ./src/service/finance.service.js